import {
  WhmCard,
  WhmTypography,
  whmTheme,
  WhmStack,
  WhmBox,
} from "@securitize/reactjs-whm";
import React, { ReactNode } from "react";

interface InfoCardProps {
  title: ReactNode;
  subtitle?: ReactNode;
  disclaimer?: ReactNode;
  footer?: ReactNode;
  smallPadding?: boolean;
  children?: React.ReactNode;
  action?: React.ReactNode;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  subtitle,
  disclaimer,
  footer,
  smallPadding,
  children,
  action,
}) => {
  return (
    <WhmCard
      variant="outlined"
      sx={{
        padding: smallPadding ? "16px" : { xs: "16px", xl: "24px" },
        width: "100%",
      }}
    >
      <WhmStack
        flexDirection={{ xs: "column", xl: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "start", xl: "center" }}
        marginBottom={children ? "16px" : undefined}
        gap="16px"
      >
        <WhmStack width="100%">
          <WhmTypography variant="subtitle1">{title}</WhmTypography>
          {subtitle && (
            <WhmTypography
              variant="body2"
              color={whmTheme.palette.text.secondary}
            >
              {subtitle}
            </WhmTypography>
          )}
          {disclaimer && (
            <WhmTypography variant="caption" fontWeight={600} marginTop="8px">
              {disclaimer}
            </WhmTypography>
          )}
        </WhmStack>
        {action && <WhmBox flexShrink={0}>{action}</WhmBox>}
      </WhmStack>
      {children}
      {footer && (
        <WhmTypography
          variant="body2"
          sx={{
            margin: "24px 0 0 0 !important",
          }}
        >
          {footer}
        </WhmTypography>
      )}
    </WhmCard>
  );
};
